/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegionsControllerRemoveMutationResponse, RegionsControllerRemovePathParams, RegionsControllerRemove401, RegionsControllerRemove403, RegionsControllerRemove404 } from "../../models/regionsController/RegionsControllerRemove";

function getRegionsControllerRemoveUrl(id: RegionsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/regions/${id}` as const }  
  return res
}

/**
 * @summary Delete a region
 * {@link /api/v1/regions/:id}
 */
export async function regionsControllerRemove(id: RegionsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RegionsControllerRemoveMutationResponse, ResponseErrorConfig<RegionsControllerRemove401 | RegionsControllerRemove403 | RegionsControllerRemove404>, unknown>({ method : "DELETE", url : getRegionsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}